import React from 'react';
import PropTypes from 'prop-types';


import * as moodWallConstants from './moodWallConstants';
import * as styleUtils from '../../../utils/styleUtils';

import styles from './MoodWall.scss';



function MoodWall({background, children}) {

    return (
        <section className={styleUtils.toClasses(styles.moodWall, background)}>
            <div className={styleUtils.toClasses(styles.inner, 'container')}>

                {children}

            </div>
        </section>
    );
}


MoodWall.propTypes = {
    background: PropTypes.oneOf(moodWallConstants.BG_SHAPES),
    children: PropTypes.any
};

MoodWall.defaultProps = {
    background: moodWallConstants.BG_SHAPE_1
};


export default MoodWall;
